
<script>
import { layoutMethods } from "@/state/helpers";
export default {
  page: {
    title: "Coming Soon",
  },
  components: {},
  data() {
    return {
      comingSoonOverlay: true, // Set to true to enable overlay
    };
  },
  computed: {},
  methods: {
    ...layoutMethods,
  },
  async mounted() {
    this.changeTitle({ title: "Coming Soon" });
  },
};
</script>

<template>
  <div class="container-fluid">
    <!-- Coming Soon Overlay -->
    <div v-if="comingSoonOverlay" class="coming-soon-overlay">
      <div class="coming-soon-content">
        <div class="text-center">
          <i class="fas fa-wrench fa-4x mb-4 text-primary"></i>
          <h2 class="fw-bold text-dark mb-3">Coming Soon</h2>
          <p class="text-muted mb-0">This Page is under development and will be available soon.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.coming-soon-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.coming-soon-content {
  background: white;
  padding: 3rem 2rem;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 90%;
  animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
